/* --------------- open anime --------------- */
document.addEventListener('DOMContentLoaded', () => {
    const lpContent = document.getElementById('lp-content');
    if (lpContent) {
      lpContent.style.opacity = 0;
      lpContent.style.display = 'block';
      setTimeout(() => {
        lpContent.style.transition = 'opacity 1s';
        lpContent.style.opacity = 1;
      }, 0);
    }
  });
  
  /* --------------- scroll anime --------------- */
  document.addEventListener('DOMContentLoaded', () => {
    const scrollAnimeElements = document.querySelectorAll('.js-scroll_anime');
    if (scrollAnimeElements.length > 0) {
      scrollAnimation();
    }
  
    function scrollAnimation() {
      const onScroll = () => {
        const windowHeight = window.innerHeight;
        const scrollTop = window.scrollY;
  
        scrollAnimeElements.forEach((element) => {
          const elementOffsetTop = element.getBoundingClientRect().top + scrollTop;
          if (scrollTop > (elementOffsetTop - windowHeight) + 60) {
            element.classList.add('is-show');
          }
        });
      };
  
      window.addEventListener('load', onScroll);
      window.addEventListener('scroll', onScroll);
    }
  });
  
  /*-----------------------------------------------
  smooth scroll
  -----------------------------------------------*/
  document.addEventListener('DOMContentLoaded', () => {
    const links = document.querySelectorAll('a[href^="#"]');
    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const href = link.getAttribute('href');
        const target = href === '#' || href === '' ? document.documentElement : document.querySelector(href);
        if (target) {
          const position = target.getBoundingClientRect().top + window.scrollY - 120;
          window.scrollTo({
            top: position,
            behavior: 'smooth',
          });
        }
      });
    });
  });
  
  /*-----------------------------------------------
  ニュースタブ切り替え
  -----------------------------------------------*/
  document.addEventListener('DOMContentLoaded', () => {
    const tabLists = document.querySelectorAll('.tab-list');
    const panelBlocks = document.querySelectorAll('.panel-block');
  
    tabLists.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        tabLists.forEach((t) => t.classList.remove('active'));
        panelBlocks.forEach((panel) => panel.classList.remove('active'));
  
        tab.classList.add('active');
        if (panelBlocks[index]) {
          panelBlocks[index].classList.add('active');
        }
      });
    });
  });